import { BaseSelect } from '@app/components';
import { productVariationApi } from '@app/store';
import { createColumnHelper } from '@tanstack/react-table';
import { IProductVariation } from '@app/common';
import React from 'react';
import { ResourceSelect, ResourceSelectParentProps } from '../ResourceSelect';

const columnHelper = createColumnHelper<IProductVariation>();

export const ProductVariationSelect = ({ label = 'Produits', ...props }: ResourceSelectParentProps<IProductVariation>) => {
  const columns = [
    columnHelper.accessor('name', {
      header: () => (
        <BaseSelect.ListHeaderItem width="50%">
          Nom
        </BaseSelect.ListHeaderItem>
      ),
      cell: (info) => (
        <BaseSelect.ListItemCol width="50%">
          <BaseSelect.ListItemText numberOfLines={1} bold>
            {info.getValue()}
          </BaseSelect.ListItemText>
        </BaseSelect.ListItemCol>
      ),
    }),
  ];

  return (
    <ResourceSelect
      label={label}
      columns={columns}
      useQuery={productVariationApi.useReadManyProductVariationsQuery}
      {...props} />
  );
};
